export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20vibrant%20digital%20entertainment%20news%20background%20with%20abstract%20warm%20gradients%20of%20coral%20and%20soft%20peach%20tones%2C%20dynamic%20flowing%20shapes%20representing%20information%20streams%2C%20modern%20minimalist%20design%20with%20subtle%20geometric%20patterns%2C%20digital%20era%20aesthetic%2C%20clean%20composition%2C%20soft%20ambient%20light%2C%20no%20text&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="吃瓜网站背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 max-w-6xl mx-auto">
          <div className="flex-1 text-center lg:text-left w-full">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500/20 text-primary-200 text-xs font-medium mb-4">
              <i className="ri-flashlight-line text-sm"></i>
              每日更新 · 全网最新
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-3">
              吃瓜网站线路一 · 51吃瓜官网全网最新入口
            </h1>

            <p className="text-base md:text-lg text-white/80 font-heading mb-6">
              一站直达，吃瓜不迷路
            </p>

            <p className="text-sm md:text-base text-white/70 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              吃瓜网站线路一作为51吃瓜官网全网最新入口，聚合全网热门吃瓜内容，每日更新51吃瓜网址与吃瓜网站首页最新动态。无论最新娱乐爆料、社会热点追踪还是网络事件深度解读，这里都是您收藏的首选吃瓜网站，一个51吃瓜线路一入口畅享全部精彩。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
              <div className="flex items-center gap-2 text-white/80">
                <i className="ri-timer-line text-primary-400"></i>
                <span className="text-sm">每日滚动更新</span>
              </div>
              <div className="flex items-center gap-2 text-white/80">
                <i className="ri-global-line text-primary-400"></i>
                <span className="text-sm">多源实时聚合</span>
              </div>
              <div className="flex items-center gap-2 text-white/80">
                <i className="ri-shield-check-line text-primary-400"></i>
                <span className="text-sm">安全匿名浏览</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                className="whitespace-nowrap w-full sm:w-auto px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-lg transition-all cursor-pointer text-sm flex items-center justify-center gap-2"
              >
                <i className="ri-compass-3-line"></i>
                浏览专题合集
              </a>
              <a
                href="#topics"
                className="whitespace-nowrap w-full sm:w-auto px-6 py-3 bg-white/10 hover:bg-white/20 text-white font-medium rounded-lg transition-all cursor-pointer text-sm border border-white/20 flex items-center justify-center gap-2"
              >
                <i className="ri-fire-line"></i>
                查看热门话题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20digital%20illustration%20of%20a%20smartphone%20floating%20amongst%20colorful%20news%20bubbles%20and%20social%20media%20icons%2C%20warm%20coral%20and%20teal%20accents%2C%20clean%20minimal%20design%2C%20soft%20glowing%20effects%2C%20editorial%20illustration%20style%2C%20flat%20design%20with%20subtle%20gradients%2C%20playful%20modern%20aesthetic%2C%20no%20text%20no%20letters&width=600&height=500&seq=hero-visual-2026&orientation=landscape"
                alt="吃瓜网站线路一主视觉"
                className="w-full h-auto rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}